import React from 'react';
import PropTypes from 'prop-types';
import cssModule from 'react-css-modules';
import { isEmpty as _isEmpty } from 'lodash';

import SuspensionBox from 'newDesign/modules/live/components/footer/footerBody/tournamentInfo/iceHockey/SuspensionBox';
import { matchStatusIds } from 'constants/enum';

import style from 'newDesign/modules/live/components/footer/Footer.scss';

const Suspensions = ({ timeInfo, matchStatusId, side }) => {
  let competitorSuspensions = [];

  if (timeInfo && timeInfo.suspensions) {
    competitorSuspensions = timeInfo.suspensions[side] || [];
  } else {
    return null;
  }

  return (
    <div styleName='lframe-meta__event' className='flex items-start'>
      <div className='flex items-center'>
        {competitorSuspensions.map((suspension, i) => (
          <SuspensionBox
            key={i}
            running={timeInfo.running}
            played={timeInfo.played}
            suspensionTime={suspension}
            matchStatusId={matchStatusId}
          />
        ))}

        {!_isEmpty(competitorSuspensions) && (
          <svg className='h-full' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' style={{ display: 'block' }}>
            <path
              d='M31.6,92.1l4.8,4.7c-0.9,0.9-2,1.6-3.3,2.1c-1.3,0.6-2.6,0.8-3.9,0.8c-2.8,0-5.2-1-7.2-2.9  c-2-2-2.9-4.3-2.9-7.1c0-1.4,0.2-2.7,0.7-3.9c0.6-1.3,1.3-2.3,2.2-3.3l4.8,4.7c-0.4,0.3-0.6,0.6-0.8,1.1c-0.1,0.4-0.2,0.9-0.2,1.4  c0,0.4,0.1,0.8,0.2,1.3c0.2,0.4,0.5,0.8,0.8,1.2c0.6,0.6,1.4,0.9,2.3,0.9C30.1,93.1,30.9,92.7,31.6,92.1z M95.1,17.8L71.6,41.3  c0.8,0.8,1.6,1.6,2.4,2.4c0.8,0.8,1.4,1.3,1.6,1.5c2.7,2.6,4.7,5.7,6.2,9.2c1.5,3.5,2.3,7.2,2.3,11.2c0,4-0.7,7.7-2.2,11.2  c-1.5,3.5-3.6,6.6-6.3,9.2c-2.6,2.6-5.6,4.7-9.1,6.2c-3.5,1.5-7.2,2.2-11.2,2.2s-7.7-0.7-11.2-2.2c-3.5-1.5-6.6-3.6-9.2-6.2  c-2.6-2.7-4.7-5.7-6.2-9.2c-1.5-3.5-2.2-7.2-2.2-11.2c0-4,0.7-7.7,2.2-11.2c1.5-3.6,3.6-6.7,6.3-9.2l2.5-2.5  c0.3-0.4,0.6-0.6,1.1-0.7c0.4-0.2,0.9-0.3,1.4-0.3c0.4,0,0.8,0.1,1.3,0.3c0.4,0.1,0.8,0.4,1.1,0.7l3,2.9l1.6-11.4  c0.1-0.3,0.2-0.7,0.3-0.9c0.2-0.4,0.5-0.7,0.7-0.9L78.6,1.4c0.3-0.4,0.6-0.6,1.1-0.7c0.4-0.2,0.9-0.3,1.4-0.3c0.4,0,0.8,0.1,1.3,0.3  c0.4,0.1,0.8,0.4,1.1,0.7L95.1,13c0.3,0.3,0.5,0.6,0.6,1.1c0.2,0.4,0.3,0.9,0.3,1.4c0,0.4-0.1,0.8-0.3,1.3  C95.6,17.1,95.4,17.5,95.1,17.8z M88,15.5L81,8.5L53.2,36.2l-2.4,16.9c-0.1,0.8-0.4,1.5-1.1,2.1c-0.6,0.6-1.4,0.8-2.2,0.8  c-0.5,0-0.9-0.1-1.4-0.2c-0.4-0.2-0.8-0.5-1.1-0.8l-5.4-5.4l-0.2,0.2c-2,2-3.6,4.4-4.8,7.1c-1.1,2.7-1.7,5.5-1.7,8.5  c0,3.1,0.6,6,1.7,8.7c1.2,2.7,2.8,5,4.7,7c2,2,4.4,3.5,7.1,4.7c2.7,1.2,5.5,1.8,8.6,1.8c3.1,0,6-0.6,8.6-1.8c2.7-1.2,5.1-2.8,7-4.7  c2-2,3.6-4.4,4.8-7c1.1-2.7,1.7-5.6,1.7-8.7c0-3-0.6-5.8-1.8-8.5c-1.1-2.7-2.7-5.1-4.7-7.1c-0.5-0.5-1.6-1.5-3.3-3  c-1.6-1.5-2.6-2.5-2.9-2.7c-0.4-0.3-0.8-0.7-1.1-1.2c-0.2-0.5-0.3-1-0.3-1.6c0-0.4,0.1-0.8,0.2-1.3c0.2-0.4,0.5-0.8,0.7-1.1L88,15.5  z M24.4,37.1c0-0.9-0.4-1.7-1.1-2.3c-0.6-0.7-1.4-1.1-2.3-1.1H7.6c-0.9,0-1.7,0.4-2.4,1.1c-0.6,0.6-0.9,1.4-0.9,2.3  c0,0.9,0.3,1.7,0.9,2.4c0.7,0.6,1.5,0.9,2.4,0.9h13.4c0.9,0,1.7-0.3,2.3-0.9C24.1,38.8,24.4,38,24.4,37.1z M24.9,25.3  c0.3,0.3,0.6,0.5,1.1,0.7c0.4,0.1,0.8,0.2,1.3,0.2c0.9,0,1.7-0.3,2.3-0.9c0.7-0.6,1.1-1.4,1.1-2.4c0-0.4-0.1-0.8-0.3-1.3  c-0.1-0.4-0.4-0.8-0.6-1.1L20,11c-0.3-0.3-0.6-0.5-1.1-0.6c-0.4-0.2-0.8-0.3-1.3-0.3c-0.9,0-1.7,0.4-2.4,1.1  c-0.6,0.6-0.9,1.4-0.9,2.3c0,0.5,0.1,0.9,0.2,1.4c0.2,0.4,0.5,0.7,0.7,0.9L24.9,25.3z M41.2,20.5c0.9,0,1.7-0.3,2.3-0.9  c0.7-0.6,1.1-1.4,1.1-2.4V3.7c0-0.9-0.4-1.7-1.1-2.3c-0.6-0.7-1.4-1.1-2.3-1.1c-0.9,0-1.7,0.4-2.4,1.1c-0.6,0.6-0.9,1.4-0.9,2.3  v13.4c0,1,0.3,1.8,0.9,2.4C39.5,20.2,40.3,20.5,41.2,20.5z'
              fill='currentColor'
            />
          </svg>
        )}
      </div>
    </div>
  );
};

Suspensions.propTypes = {
  timeInfo: PropTypes.object,
  matchStatusId: PropTypes.number,
  side: PropTypes.string.isRequired,
};

Suspensions.defaultProps = {
  timeInfo: {},
  matchStatusId: matchStatusIds.not_started,
};

const SuspensionsStyled = cssModule(Suspensions, style);
export default SuspensionsStyled;
